<template>
  <CTabs variant="tabs" class="nav-tabs-boxed" v-if="dataLoaded">
    <CTab title="Fabricantes">
      <TintometricoFabricante
          :key="uniqueKey"
          @fabricantes-changed="onFabricantesChanged"
      />
    </CTab>
    <CTab title="Integrações">
      <TintometricoIntegracao
          :fabricantes="fabricantes"
          :fabricantesDetalhes="fabricantesDetalhes"
          :filiais="filiais"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Linhas">
      <TintometricoLinha
          :fabricantes="fabricantes"
          :integracoes="integracoes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Bases">
      <TintometricoBase
          :fabricantes="fabricantes"
          :integracoes="integracoes"
          :embalagens="embalagens"
          :linhas="linhas"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Cores">
      <TintometricoCor
          :fabricantes="fabricantes"
          :integracoes="integracoes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Corantes">
      <TintometricoCorante
          :fabricantes="fabricantes"
          :integracoes="integracoes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Embalagens">
      <TintometricoEmbalagem
          :fabricantes="fabricantes"
          :integracoes="integracoes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Eventos">
      <TintometricoEventos
          :integracoes="integracoes"
          :filiais="filiais"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Diagnóstico">
      <TintometricoDiagnostico
          :integracoes="integracoes"
          :filiais="filiais"
          :key="uniqueKey"
      />
    </CTab>
  </CTabs>
</template>

<script>

import TintometricoFabricante from "@/views/Tintometrico/TintometricoFabricante.vue";
import TintometricoIntegracao from "@/views/Tintometrico/TintometricoIntegracao.vue";
import TintometricoLinha from "@/views/Tintometrico/TintometricoLinha.vue";
import TintometricoBase from "@/views/Tintometrico/TintometricoBase.vue";
import TintometricoCor from "@/views/Tintometrico/TintometricoCor.vue";
import TintometricoCorante from "@/views/Tintometrico/TintometricoCorante.vue";
import TintometricoEmbalagem from "@/views/Tintometrico/TintometricoEmbalagem.vue";
import TintometricoEventos from "@/views/Tintometrico/TintometricoEventos.vue";
import TintometricoDiagnostico from "@/views/Tintometrico/TintometricoDiagnostico.vue";
import { get} from '@/helpers/apiRequest';

export default {
  name: 'Tintometrico',
  components: {
    TintometricoFabricante,
    TintometricoIntegracao,
    TintometricoLinha,
    TintometricoBase,
    TintometricoCor,
    TintometricoCorante,
    TintometricoEmbalagem,
    TintometricoEventos,
    TintometricoDiagnostico
  },
  data(){
    return {
        filiais: {},
        fabricantes: {},
        integracoes: [],
        embalagens: [],
        linhas: [],
        fabricantesDetalhes: [],
        uniqueKey: 0,
        dataLoaded: false
    };
  },
  async mounted() {
    await this.loadData().then(() => {
      setTimeout(() => {
        this.dataLoaded = true
      }, 1000)
    })
  },
  methods: {
    loadFiliais(){
      get('/admin/tintometrico/filiais-ativas')
          .then((json) => {
            json.map((filial) => {
              this.$set(this.filiais, filial.id, filial.desc);
            });
          })
    },
    // Lista de integrações: o catálogo (linha, base, cor, corante) passou a ter uma
    // cópia por integração quando o fabricante tem mais de uma fonte (duas
    // máquinas, por exemplo), então as telas precisam mostrar e filtrar por ela.
    // Sem page/take na URL: com eles a API responde paginado
    // ({ paginator, itens }) e ainda limita ao perPage do controller, o que
    // deixaria o filtro de origem incompleto. Sem eles vem a coleção inteira.
    loadIntegracoes(){
      return get('/admin/tintometrico/integracao')
          .then((json) => {
            const lista = json.itens || json.data || json;
            this.integracoes = (Array.isArray(lista) ? lista : []).map((integracao) => ({
              id: integracao.id,
              descricao: integracao.descricao,
              fabricanteId: String(integracao.fabricanteId || ''),
              // Filiais que a máquina atende: o diagnóstico só oferece as lojas
              // dela, porque perguntar por uma filial que ela não atende sempre
              // devolve a mesma resposta.
              filiais: Array.isArray(integracao.filiais) ? integracao.filiais.map(String) : [],
            }));
          })
    },
    // Embalagens e linhas alimentam os filtros da aba de bases. Mesma regra do
    // loadIntegracoes: sem page/take para vir a coleção inteira, senão o filtro
    // ficaria limitado ao perPage do controller.
    loadEmbalagens(){
      return get('/admin/tintometrico/embalagem')
          .then((json) => {
            const lista = json.itens || json.data || json;
            this.embalagens = (Array.isArray(lista) ? lista : []).map((embalagem) => ({
              id: embalagem.id,
              nome: embalagem.volumeMl ? `${embalagem.nome} (${embalagem.volumeMl} ml)` : embalagem.nome,
              fabricanteId: String(embalagem.fabricanteId || ''),
              integracaoId: String(embalagem.integracaoId || ''),
            }));
          })
    },
    loadLinhas(){
      return get('/admin/tintometrico/linha')
          .then((json) => {
            const lista = json.itens || json.data || json;
            this.linhas = (Array.isArray(lista) ? lista : []).map((linha) => ({
              id: linha.id,
              nome: linha.nome,
              fabricanteId: String(linha.fabricanteId || ''),
              integracaoId: String(linha.integracaoId || ''),
            }));
          })
    },
    loadFabricantes(){
      return get('/admin/tintometrico/fabricantes')
          .then((json) => {
            this.fabricantesDetalhes = json;
            const novoMap = {};
            json.forEach((fabricante) => {
              novoMap[fabricante.id] = fabricante.chave;
            });
            this.fabricantes = novoMap;
          })
    },
    async loadData() {
      await this.loadFabricantes();
      await this.loadFiliais();
      await this.loadIntegracoes();
      await this.loadEmbalagens();
      await this.loadLinhas();
    },
    onFabricantesChanged() {
      return this.loadFabricantes();
    }
  },
}

</script>

<style src="./tintometrico.css"></style>
